import { isOciMarketChannel, type MarketChannel } from "@/lib/market/market-channel"

export type CatalogVisibilityMode = "static" | "oci-authenticated" | "authenticated"

const CATALOG_VISIBILITY_MODE_BY_CHANNEL: Record<MarketChannel, CatalogVisibilityMode> = {
  www: "static",
  oci: "oci-authenticated",
}

export function getCatalogVisibilityMode(channel: MarketChannel): CatalogVisibilityMode {
  return CATALOG_VISIBILITY_MODE_BY_CHANNEL[channel] ?? "static"
}

export function canCatalogVisibilityDifferForChannel(mode: CatalogVisibilityMode, channel: MarketChannel): boolean {
  if (mode === "static") {
    return false
  }

  return mode === "authenticated" || isOciMarketChannel(channel)
}

export function shouldResolveCatalogVisibility({
  mode,
  channel,
  isAuthenticated,
}: {
  mode: CatalogVisibilityMode
  channel: MarketChannel
  isAuthenticated: boolean
}) {
  if (!isAuthenticated) {
    return false
  }

  if (mode === "authenticated") {
    return true
  }

  return mode === "oci-authenticated" && isOciMarketChannel(channel)
}
